const DEFAULT_INTERVAL = 65;
const DEFAULT_THRESHOLD = -50;

/**
 * Builds a speak observer object
 *
 * @param {Object} options
 * @property {Integer} options.interval Time between status checks
 * @property {Integer} options.threshold Threshold value to consider that the stream is speaking
 * @property {Function} options.start Function to run when the observer starts
 * @property {Function} options.stop Function to run when the observer stops
 */
export const createSpeakObserver = (stream, options) => {
  options = options || {};
  let that = {};

  var interval = options.interval || DEFAULT_INTERVAL;
  var threshold = options.threshold || DEFAULT_THRESHOLD;

  var AudioContextType = window.AudioContext || window.webkitAudioContext;
  var audioContext = new AudioContextType();
  // Setup an analyser
  var analyser = audioContext.createAnalyser();
  analyser.fftSize = 512;
  analyser.smoothingTimeConstant = 0.1;
  var fftBins = new window.Float32Array(analyser.fftSize);
  // Setup a source node and connect it to the analyser
  var sourceNode = audioContext.createMediaStreamSource(stream);
  sourceNode.connect(analyser);

  var speaking = false;
  var loop = null;
  var history = new Array(10).fill(0);

  that.start = function () {
    var loop = window.setInterval(function () {
      if (audioContext.state === "suspended") {
        audioContext.resume();
      } else {
        poll();
      }
    }, interval);
  };

  that.destroy = function () {
    window.clearInterval(loop);
  };

  that.isSpeaking = function () {
    return speaking;
  };

  function poll() {
    var audioDetected = isAudioDetected();
    var sum;

    if (audioDetected && !speaking) {
      sum = history.slice(history.length - 3).reduce((s, i) => s + i, 0);
      if (sum >= 2) {
        speaking = true;
        if (options.start) {
          options.start();
        }
      }
    } else if (!audioDetected && speaking) {
      sum = history.reduce((s, i) => s + i, 0);
      if (sum === 0) {
        speaking = false;
        if (options.stop) {
          options.stop();
        }
      }
    }
    history.shift();
    history.push(0 + audioDetected);
  }

  function isAudioDetected() {
    analyser.getFloatFrequencyData(fftBins);
    // Skip the first 4... simply because hark does it
    // (too low frequencies to be voice, I guess)
    for (var i = 4, ii = fftBins.length; i < ii; i++) {
      if (fftBins[i] > threshold && fftBins[i] < 0) {
        return true;
      }
    }
    return false;
  }

  return that;
};
